/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./no-content.component";
var styles_NoContentComponent = [];
var RenderType_NoContentComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_NoContentComponent, data: {} });
export { RenderType_NoContentComponent as RenderType_NoContentComponent };
export function View_NoContentComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 1, "h1", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["404: page missing"]))], null, null); }
export function View_NoContentComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "no-content", [], null, null, null, View_NoContentComponent_0, RenderType_NoContentComponent)), i0.ɵdid(1, 49152, null, 0, i1.NoContentComponent, [], null, null)], null, null); }
var NoContentComponentNgFactory = i0.ɵccf("no-content", i1.NoContentComponent, View_NoContentComponent_Host_0, {}, {}, []);
export { NoContentComponentNgFactory as NoContentComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/no-content/no-content.component.ngfactory.js.pre-build-optimizer.js